import { render, staticRenderFns } from "./AppointmentNotice.vue?vue&type=template&id=d992ef44"
import script from "./AppointmentNotice.vue?vue&type=script&lang=js"
export * from "./AppointmentNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports